module.exports = __webpack_public_path__ + "static/media/logo-tijuana.f7790d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/places/logo-tijuana.png
// module id = 1093
// module chunks = 0